import React, { useEffect, useState } from "react";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../../components/comman/ErrorMessage";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import BgBlurLoader from "../../../../components/Loaders/BgBlurLoader";

export default function AddSalaryHead() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [salaryHeadList, setSalaryHeadList] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm();

  const EditData = location?.state?.data;

  useEffect(() => {
    GetSalaryHead();
  }, []);

  useEffect(() => {
    if (EditData) {
      const initialBasedValue = EditData?.isInitialBased;

      const isInitial =
        typeof initialBasedValue === "boolean"
          ? initialBasedValue
          : !!initialBasedValue;

      reset({
        name: EditData?.name,
        type: EditData?.type,
        wantToShowInOfferLetter: EditData?.wantToShowInOfferLetter || false,
        fromEmployeer: EditData?.fromEmployeer || false,
        isInitialBased: isInitial,
        initialBasedHeadId:
          typeof initialBasedValue === "string" ||
            typeof initialBasedValue === "number"
            ? initialBasedValue
            : "",
      });
    } else {
      reset({
        wantToShowInOfferLetter: false,
        fromEmployeer: false,
        isInitialBased: false,
        initialBasedHeadId: "",
      });
    }
  }, [EditData]);

  const GetSalaryHead = () => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_salary_head + `isBase=true`;
    setIsLoadingList(true);
    callApi(Url, options).then((res) => {
      setIsLoadingList(false);
      if (res?.status === true) {
        setSalaryHeadList(res?.data?.salaryHead);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const onSubmit = (data) => {
    const postData = {
      name: data?.name,
      type: data?.type,
      wantToShowInOfferLetter: !!data?.wantToShowInOfferLetter,
      fromEmployeer: !!data?.fromEmployeer,
      isInitialBased: data?.isInitialBased ? data?.initialBasedHeadId : null,
    };

    const option = {
      method: "POST",
      data: postData,
    };

    const endPoint = EditData
      ? apiUrl.update_salary_head + `?salaryHeadId=${EditData?.id}`
      : apiUrl.create_salary_head;

    setIsLoading(true);
    callApi(endPoint, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        toast.success(res?.message);
        navigate(-1);
        reset();
      } else {
        toast.error(res?.message);
      }
    });
  };

  return (
    <>
      {isLoadingList && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">{EditData ? "Update" : "Add"} Salary Head</h1>
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="tab-content" id="pills-tabContent">

                <div className="row mb-5">
                  {/* Name */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3">
                    <div className="form-group mb-3">
                      <label htmlFor="firmName" className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""
                          }`}
                        placeholder="Head Name"
                        {...register("name", {
                          required: "This field is Required",
                        })}
                      />
                      <ErrorMessage message={errors?.name?.message} />
                    </div>
                  </div>

                  {/* Type */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Type<span className="text-danger">*</span>
                      </label>
                      <select
                        className={`form-control form-select ${errors.type ? "is-invalid" : ""
                          }`}
                        aria-label="Default select example"
                        {...register("type", {
                          required: "This field is required",
                        })}
                      >
                        <option value="" className="text-muted">
                          Select Head type
                        </option>
                        <option value={"earning"}>Earning</option>
                        <option value={"deduction"}>Deduction</option>
                      </select>
                      <ErrorMessage message={errors?.type?.message} />
                    </div>
                  </div>

                  {/* Show in Offer Letter Toggle */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3">
                    <div className="form-group mb-3">
                      <label className="form-label d-block">
                        Show in Appointment Letter
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-check form-switch mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input rounded-5"
                          id="showInOfferLetter"
                          {...register("wantToShowInOfferLetter")}
                          defaultChecked={false}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="showInOfferLetter"
                        >
                          {watch("wantToShowInOfferLetter") ? "Yes" : "No"}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* From Employer Toggle */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3">
                    <div className="form-group mb-3">
                      <label className="form-label d-block">
                        From Employer
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-check form-switch mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input rounded-5"
                          id="fromEmployer"
                          {...register("fromEmployeer")}
                          defaultChecked={false}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="fromEmployer"
                        >
                          {watch("fromEmployeer") ? "Yes" : "No"}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Is Initial Based Toggle */}
                  <div className="col-12 col-md-6 col-lg-4 mb-3">
                    <div className="form-group mb-4">
                      <label className="form-label d-block">
                        Is Initial Based
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-check form-switch mt-2">
                        <input
                          type="checkbox"
                          className="form-check-input rounded-5"
                          id="isInitialBased"
                          checked={!!watch("isInitialBased")}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setValue("isInitialBased", checked);
                            if (!checked)
                              setValue("initialBasedHeadId", "");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isInitialBased"
                        >
                          {watch("isInitialBased") ? "Yes" : "No"}
                        </label>
                      </div>
                    </div>
                  </div>

                  {watch("isInitialBased") && (
                    <div className="col-12 col-md-6 col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="form-label">
                          Select Salary Head{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`form-select ${errors.initialBasedHeadId ? "is-invalid" : ""
                            }`}
                          {...register("initialBasedHeadId", {
                            required: "Please select a salary head",
                          })}
                          value={watch("initialBasedHeadId") || ""}
                          onChange={(e) =>
                            setValue("initialBasedHeadId", e.target.value)
                          }
                        >
                          <option value="">Select Salary Head</option>
                          {salaryHeadList?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage
                          message={errors?.initialBasedHeadId?.message}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* Buttons */}
                <div className="d-flex align-items-center justify-content-end gap-4">
                  <button
                    className="btn btn-secondary px-5"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary px-5" type="submit">
                    {isLoading ? <Spinner /> : EditData ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
